import {Badge, MantineColor} from '@mantine/core';

const statusColorMap: Record<string, MantineColor> = {
    CREATING: 'blue',
    ACTIVE: 'green',
    UPDATING: 'cyan',
    FAILED: 'red',
    DELETING: 'orange',
    ARCHIVED: 'gray',
    IMPORTED: 'violet',
    MIGRATING: 'yellow',
};

export const PipelineStatusBadge = ({status}: { status?: string }) => {
    if (!status) return null;

    const color = statusColorMap[status] || 'gray';

    return (
        <Badge color={color} variant='light'>
            {status}
        </Badge>
    );
};
